import Badge from 'antd/es/badge';
import List from 'antd/es/list';
import theme from 'antd/es/theme';
import { useMemo } from 'react';
import styled from 'styled-components';

import { type Source } from '@mai/types';

import {
  SectionHeader,
  SectionTitle,
} from '../../../components/TaskDescription';

import { useSourcesQuery } from '@queries/sources';

const ContentSection = styled.div`
  margin-bottom: 24px;

  &:last-child {
    margin-bottom: 0;
  }
`;

const SourcesList = styled(List<Source>)`
  flex: 1;
  overflow-y: auto;
`;

function baseUrlFromUrl(url: string) {
  const urlObj = new URL(url);
  return urlObj.origin;
}

const AgentRunResources: React.FC<{ agentRunId: string }> = ({
  agentRunId,
}) => {
  const { token } = theme.useToken();

  const sourcesQuery = useSourcesQuery(
    {
      agentRunIds: [agentRunId],
    },
    !!agentRunId,
  );

  const sources = useMemo(() => {
    return sourcesQuery.data ?? [];
  }, [sourcesQuery.data]);

  return (
    <ContentSection>
      <SectionHeader>
        <SectionTitle level={4} style={{ margin: 0 }}>
          Resources
          <Badge
            count={sources.length}
            color={token.colorPrimary}
            size="small"
            offset={[5, -3]}
          />
        </SectionTitle>
      </SectionHeader>
      <SourcesList
        dataSource={sources}
        renderItem={(source) => (
          <List.Item key={source.sourceId}>
            <div style={{ display: 'flex', flexDirection: 'column' }}>
              <span>{source.title}</span>
              {source.url ? (
                <a href={source.url} target="_blank" rel="noopener noreferrer">
                  {baseUrlFromUrl(source.url)}
                </a>
              ) : null}
            </div>
          </List.Item>
        )}
      />
    </ContentSection>
  );
};

export default AgentRunResources;
